import { render, staticRenderFns } from "./PreOpHoldRecords.vue?vue&type=template&id=b504e4ec&"
import script from "./PreOpHoldRecords.vue?vue&type=script&lang=js&"
export * from "./PreOpHoldRecords.vue?vue&type=script&lang=js&"
import style0 from "./PreOpHoldRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports